import React from "react";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {LoyaltyBarSectionBox} from "./boxes/loyalty-bar-section.box";
import {LoyaltyBarWrapperComponent} from "./loyalty-bar-wrapper.component";

@observer
export class LoyaltyBar extends OrbitComponent {

  render() {
    const showLoyaltyConfig = this.services.configuration.data.drawer.showLoyalty;
    if (!showLoyaltyConfig || !showLoyaltyConfig.display)
      return null;

    return (
      <LoyaltyBarSectionBox>
        <LoyaltyBarWrapperComponent />
      </LoyaltyBarSectionBox>
    );
  }
}
